<template>
    <div class="pt-8">
        <filter-form 
            :filter="filter" 
            :departamentosList="departamentosList" 
            :ciudadesList="ciudadesList"
            @get-pedidos="getPedidos()" 
            @clear-filter-form="clearFilterForm()" 
            @get-ciudades-list="getCiudadesList()" 
        />
        
        <pedidos-table 
            :pedidos="pedidos" 
            :paginator="paginator" 
            :pageSize="pageSize"
            :canSeeSalesComission="canSeeSalesComission"
            @get-pedidos="getPedidos()" 
            @change-page="changePage($event)" 
        />
    </div>
</template>
<script>
import PedidosTable from '../components/PedidosTable.vue'
import FilterForm from '../components/FilterForm.vue'
import { mapMutations, mapState } from 'vuex'
export default {
    computed: {
        ...mapState('auth', ['user'])
    },
    data(){
        return{
            pedidos: [],
            paginator: {
                page: 1,
                totalPage: 1,
                pageSize: 10,
            },
            pageSize: [10, 25, 50, 100],
            pageOptions: "",
            filter:{
                pedidoId: "",
                vendedor: "",
                cliente: "",
                nit: "",
                departamento: "",
                ciudad: "",
                dateFrom: "",
                dateTo: new Date().toISOString().substr(0, 10),
            },
            departamentosList: [],
            ciudadesList: [],
            canSeeSalesComission: false
        }
    },
    components: {
        PedidosTable,
        FilterForm
    },
    created(){
        this.getPedidos();
        this.getDepartamentosList();
    },
    methods:{
        ...mapMutations(['setLoading']),
        async getPedidos() {
            this.pageOptions = { 
                pageNumber:   this.paginator.page, 
                pageSize:     this.paginator.pageSize,
                pedidoId:     this.filter.pedidoId,
                vendedor:     this.filter.vendedor,
                cliente:      this.filter.cliente,
                nit:          this.filter.nit,
                departamento: this.filter.departamento,
                ciudad:       this.filter.ciudad,
                dateFrom:     this.filter.dateFrom,
                dateTo:       this.filter.dateTo,
            }
            if(this.user.permissions.includes('can_supervise_sales_comission') 
            || this.user.permissions.includes('can_access_to_own_sales_comission_detail')){
                this.canSeeSalesComission = true;
            }
            this.setLoading(true)
            await this.$conectar.post('order/api/get-orders-list', this.pageOptions)
            .then(response =>{
                this.pedidos = response.data.pedidosLists;
                this.paginator.totalPage = response.data.totalPages;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async getDepartamentosList() {
            this.setLoading(true)
            await this.$conectar.post('direcciones/get-departamentos-list')
            .then(response =>{
                this.departamentosList = response.data.departamentosList;
            })
            .catch(e => {
                console.log(e.response);
            })
            this.setLoading(false)
        },
        async getCiudadesList() {
            if(this.filter.departamento != ''){
                this.filter.ciudad = "";
                this.departamentoSelected = { 
                    departamento_id:   this.filter.departamento, 
                }
                this.setLoading(true)
                await this.$conectar.post('direcciones/get-ciudades-list', this.departamentoSelected)
                .then(response =>{
                    this.ciudadesList = response.data.ciudadesList;
                })
                .catch(e => {
                    console.log(e.response);
                })
                this.setLoading(false)
            }else{
                this.ciudadesList = [];
            }
        },
        changePage(page){
            this.paginator.page = page;
            this.getPedidos();
        },
        clearFilterForm(){
            this.filter.pedidoId = "";
            this.filter.vendedor = "";
            this.filter.cliente = "";
            this.filter.nit = "";
            this.filter.departamento = "";
            this.filter.ciudad = "";
            this.filter.dateFrom = "";
            this.filter.dateTo = new Date().toISOString().substr(0, 10);
            this.paginator.pageSize = 10;
        },
    }
}
</script>

<style scoped>
.singleLine th {
  white-space: nowrap !important;
  overflow: hidden !important;
}
.singleLineTd td {
  white-space: nowrap !important;
  overflow: hidden !important;
}
</style>